module.exports = __webpack_public_path__ + "images/emoji/purple_heart.ed08a2242eab492cda91.png";